import type { SignalTimeframeDTO } from "../models/miscellaneous/SignalTimeframeDTO";

export const areEqualTimeframes = (
    filters: Readonly<SignalTimeframeDTO>,
    comparedFilters: Readonly<SignalTimeframeDTO>,
): boolean => {
    return filters.period === comparedFilters.period && filters.periodAmount === comparedFilters.periodAmount;
};
